<atlas-modal #logout [headerRef]="logoutheader" [contentRef]="logoutcontent" [footerRef]="logoutfooter"
  [showDialogActions]="false">
</atlas-modal>
<ng-template #logoutheader>
  <h4>Logout</h4>
</ng-template>
<ng-template #logoutcontent>
  <p>Are you sure you want to logout?</p>
</ng-template>
<ng-template #logoutfooter>
  <div class="row align-right is-collapse-child mos-c-modal__actions">
    <div class="columns shrink">
      <atlas-button (click)="cancel()">No</atlas-button>

    </div>
    <div class="columns shrink">
      <atlas-button [size]="'medium'" [style]="'strong'" [color]="'brand'" (click)="continue()">Yes</atlas-button>

    </div>
  </div>
</ng-template>